export const getAuthToken = () => {
    return localStorage.getItem("token") || sessionStorage.getItem("token");
  };